import { render, staticRenderFns } from "./VD01.vue?vue&type=template&id=24e2f420&"
import script from "./VD01.vue?vue&type=script&lang=js&"
export * from "./VD01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports